/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'underscore';
import { Checkbox } from './controls';
import type { IChoiceGroupState } from './types';

export interface ICheckboxGroupProps<T = any> {
  checked?: T[];
  getItemId?: (item: T, index: number) => string;
  getItemValue?: (item: T, index: number) => string | number;
  items: T[];
  name?: string;
  onChange: (checked: T[]) => void;
  renderItem?: (item: T, index: number) => React.ReactNode;
  className?: string;
}

export type ICheckboxGroupState = Required<IChoiceGroupState>;

export class CheckboxGroup<T = any> extends React.PureComponent<ICheckboxGroupProps<T>, ICheckboxGroupState> {
  static defaultProps: Partial<ICheckboxGroupProps<any>> = {
    checked: [],
    getItemId: (item: any, index: number) => String(index),
    getItemValue: undefined,
    name: undefined,
    renderItem: () => null,
    className: undefined,
  };

  static getDerivedStateFromProps(nextProps: ICheckboxGroupProps<any>, prevState: ICheckboxGroupState) {
    return {
      name: nextProps.name || prevState.name || _.uniqueId('checkbox-group-'),
    };
  }

  constructor(props: ICheckboxGroupProps<T>) {
    super(props);
    this.state = { name: props.name || _.uniqueId('checkbox-group-') };
  }

  render() {
    const getItemValue = this.props.getItemValue || this.props.getItemId;

    return (
      <>
        {this.props.items.map((item: T, index: number) => {
          const id = this.props.getItemId!(item, index);
          const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            const checked = event.target.checked
              ? [...(this.props.checked || []), item]
              : _.without(this.props.checked || [], item);

            this.props.onChange(checked);
          };

          return (

            <Checkbox
              key={id}
              id={`${this.state.name}-${id}`}
              className={this.props.className}
              checked={_.contains(this.props.checked || [], item)}
              name={this.state.name}
              onChange={onChange}
              value={getItemValue!(item, index)}
            >
              {this.props.renderItem && this.props.renderItem(item, index)}
            </Checkbox>
          );
        })}
      </>
    );
  }
}
